import paths from 'routes/routes';

import { ROLES } from '@src/globals';
import useLocales from '@src/locales/use-locales';
import { NavGroupType } from '@src/types/main';

const useNavItems = () => {
  const { t } = useLocales();

  const navItems: NavGroupType[] = [
    {
      id: 'group_1',
      type: 'group',
      label: t('navigation.groups.general'),
      entries: [
        {
          id: 'group_1__item_1',
          type: 'item',
          path: paths.dashboard.root,
          label: t('navigation.items.dashboard'),
          icon: 'material-symbols:dashboard-outline',
          allowedRoles: [ROLES.USER, ROLES.ADMIN],
        },
      ],
    },
    {
      id: 'group_2',
      type: 'group',
      label: t('navigation.groups.services'),
      entries: [
        {
          id: 'group_2__item_1',
          type: 'item',
          path: paths.dashboard.textAnalysis,
          label: t('navigation.items.textAnalysis'),
          icon: 'material-symbols:screen-search-desktop-outline',
          allowedRoles: [ROLES.USER, ROLES.ADMIN],
        },
        {
          id: 'group_2__subGroup_1',
          type: 'subGroup',
          subGroupLabel: t('navigation.subGroups.debunkedClaims'),
          icon: 'material-symbols:document-scanner-outline',
          entries: [
            {
              id: 'group_2__subGroup_1__item_1',
              type: 'item',
              path: paths.dashboard.debunkedClaims.list,
              label: t('navigation.items.debunkedClaimsList'),
              allowedRoles: [ROLES.USER, ROLES.ADMIN],
              icon: 'mdi:dot',
            },
            {
              id: 'group_2__subGroup_1__item_2',
              type: 'item',
              path: paths.dashboard.debunkedClaims.add,
              label: t('navigation.items.debunkedClaimsAdd'),
              allowedRoles: [ROLES.USER, ROLES.ADMIN],
              icon: 'mdi:dot',
            },
          ],
        },
      ],
    },
    {
      id: 'group_3',
      type: 'group',
      label: t('navigation.groups.userManagement'),
      entries: [
        {
          id: 'group_3__item_1',
          type: 'item',
          path: paths.dashboard.userManagement.add,
          label: t('navigation.items.userInvitation'),
          icon: 'material-symbols:manage-accounts',
          allowedRoles: [ROLES.ADMIN],
        },
        {
          id: 'group_3__item_2',
          type: 'item',
          path: paths.dashboard.userManagement.list,
          label: t('navigation.items.userList'),
          icon: 'material-symbols:user-attributes',
          allowedRoles: [ROLES.ADMIN],
        },
      ],
    },
  ];

  return navItems;
};

export default useNavItems;
